import { Controller } from "stimulus";
import parkedService from "./parked_service";

export default class extends Controller {

    connect() {
        parkedService.ready.then(() => this.update());
        parkedService.on("update", () => this.update());
    }

    update() {
        let count = parkedService.count;
        if (count === 0) {
            this.element.innerHTML = "";
            this.element.classList.add("hidden");
        } else {
            this.element.innerHTML = `${count}`;
            this.element.classList.remove("hidden");
        }
    }
}